import AAFShakaPlayer from '../all/shakaPlayer/AAFShakaPlayer';
import ShakaLib from '../all/shakaPlayer/ShakaLib';
import shakaPlayer from '../all/shakaPlayer/shakaMain';
import Asset  from '../../requests/apa/Asset';
import logger from 'src/utils/logger/logger';

class SEIRoboticsPlayer extends AAFShakaPlayer {
  constructor() {
    super();
  }

  createPlayer(options) {
    const shaka = ShakaLib.getShakaObject();
    this.prependPip = options.isPip ? '_pip' : '_full';
    this._playerContainer = window.document.createElement('div');
    this._playerContainer.style.backgroundColor = 'transparent';
    this._playerContainer.id = `Html5PlayerContainer${this.prependPip}`;
    this._playerContainer.className = 'Html5PlayerContainer';

    if (!this.streamIsImage()) {
      this.setPlayerBackground(options.backgroundImage ? options.backgroundImage : null);
      this._playerHTMLTag = window.document.createElement('video');
      this._playerHTMLTag.setAttribute('id', `Html5Player${this.prependPip}`);
      const poster = Asset.get('asset_shaka_transparent', '/images/pixel_transparent.png');
      this._playerHTMLTag.setAttribute('poster', poster);

      // Muted only apply to pip, at this moment
      if (options.muted) {
        this._playerHTMLTag.setAttribute('muted', 'muted');
      }

      this._playerHTMLTag.className = 'Html5Player';
      shakaPlayer.setVideo(this._playerHTMLTag);

      const playerShakaLocal = new shaka.Player(this._playerHTMLTag);
      shakaPlayer.setPlayer(playerShakaLocal);
      window.Player = playerShakaLocal;
      playerShakaLocal.addEventListener('error', () => {
        playerShakaLocal.retryStreaming();
      });
      this._playerContainer.appendChild(this._playerHTMLTag);
    } else {
      this.setPlayerBackground(options.src ? options.src : null);
    }

    if (!this.options.parentWrapper) {
      logger.error('parentWrapper not found');
      return;
    }

    const vWrapper = document.getElementById(this.options.parentWrapper.id);
    // vWrapper.appendChild(this._playerContainer);
    vWrapper.insertBefore(this._playerContainer, vWrapper.firstChild);

    // Add listeners...if apply
    if (!this.streamIsImage()) {
      this.addEventsListeners();
    }
  }


  loadMedia() {
    const player = shakaPlayer.getPlayer();

    if (!this._isPrepared) {
      return false;
    }
    if (this.streamIsImage()) {
      return;
    }

    if (this.options.resume && !this.options.isLive) {
      this.seek_resume = this.options.resume;
    }

    this.assetInfo = this.createAssetInfo();
    const asset = shakaPlayer.preparePlayer(this.assetInfo, this.handleStreamingError);

    const initConfig = {
      abr: {
        defaultBandwidthEstimate: 10e5,
        bandwidthUpgradeTarget: 0.7,
        bandwidthDowngradeTarget: 1.3
      }
    };

    player.configure(initConfig);

    if (this.options.src) {
      this.src = this.options.src;
      this._isOnLoaded = false;
      player
        .load(this.options.src, this.seek_resume)
        .then(() => {
          this.seek_resume = 0;
          this.setTextTrack(player);
          //Enable or disable the text displayer. If the player is in an unloaded state, the request will be applied next time content is loaded.
          player.setTextTrackVisibility(false);
        })
        .catch(e => {
          logger.debug('shaka load error', e); // Error already handled through error event.;
          this._onError(e);
        });

      if (!this.options.isPip) {
        this.setPlayerFull();
      }
    } else {
      this.destroy();
    }
  }



}

export default SEIRoboticsPlayer;



// WEBPACK FOOTER //
// ./src/devices/seirobotics/Player.js